import { get } from 'lodash';

import { AppState } from 'Interfaces/Interfaces';

const root = (state: AppState) => get(state, 'parentState');

export const getStudentDistricts = (state: AppState) => get(root(state), 'studentDistricts');
export const getStudentSites = (state: AppState) => get(root(state), 'studentSites');
